import { formatWaitClock, liveWaitStatusCopy } from '@/lib/live-wait-status'
import { testIds } from '@/lib/test-ids'

export function LiveWaitStatus({ elapsedMs }: { elapsedMs: number }) {
  const copy = liveWaitStatusCopy(elapsedMs)
  if (!copy) return null
  return (
    <p
      className="mt-1 text-xs leading-snug text-muted-foreground"
      data-testid={testIds.chatPane.streamWaitStatus}
      aria-live="polite"
    >
      {formatWaitClock(elapsedMs)} - {copy}
    </p>
  )
}
